import { render, staticRenderFns } from "./model-ocheck.vue?vue&type=template&id=54f7c6aa&scoped=true&"
import script from "./model-ocheck.vue?vue&type=script&lang=js&"
export * from "./model-ocheck.vue?vue&type=script&lang=js&"
import style0 from "./model-ocheck.vue?vue&type=style&index=0&id=54f7c6aa&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f7c6aa",
  null
  
)

export default component.exports